import { Component } from '@angular/core';
import { TableConfigService } from './table-config.service';

@Component({
  selector: 'app-parent',
  template: `
  <div class="card">
    <div class="card-body">
        <app-filter (filter)="filterData()" (clearValue)="clearFilter()"></app-filter>
        <app-tabs [tabs]="tabs" [activeTabId]="activeTabId" (tabChange)="onTabChange($event)" [tabContent]="tabContentTemplate"></app-tabs>
        <ng-template #tabContentTemplate let-tab>
          <app-stats [analyse]="tab.analyse" (submitMass)="submitMassAction(tab.analyse.id)" (exportGlobal)="exportGlobalAction(tab.analyse.id)"></app-stats>
          <app-table [columns]="tableConfig.bodyObject.columns" [data]="tab.data"></app-table>
        </ng-template>
    </div>
  </div>
  `,
})
export class ParentComponent {
  tabs = [
    // Define your tabs configuration here
  ];
  activeTabId: string;
  filterText: string;

  constructor(public tableConfig: TableConfigService) {
    this.filterText = '';
  }

  filterData() {
    this.tabs.forEach(tab => {
      tab.data = tab.data.filter(item => {
        return item.libelle.toLowerCase().includes(this.filterText.toLowerCase()) ||
          item.echeances.toLowerCase().includes(this.filterText.toLowerCase());
      });
    });
  }

  clearFilter() {
    this.tabs.forEach(tab => {
      tab.data = this.generateRandomData();
    });
    this.filterText = '';
  }

  onTabChange(event: any) {
    this.activeTabId = event.tabId;
  }

  submitMassAction(tabId: string) {
    console.log('Submit mass action for tab:', tabId);
    // Implement logic for mass action submission
  }

  exportGlobalAction(tabId: string) {
    console.log('Export global data for tab:', tabId);
    // Implement logic for exporting global data
  }

  generateRandomData() {
    const data = [];
    const numItems = Math.floor(Math.random() * 10) + 1; // Generate random number of items (1-10)
    for (let i = 0; i < numItems; i++) {
      const item = {
        libelle: 'Libellé ' + i,
        echeances: 'Echéances ' + i,
        nb_parcelle: Math.floor(Math.random() * 100), // Random number of parcels
        created_at: new Date().toISOString(), // Current date as string
        updated_at: new Date().toISOString(), // Current date as string
        matricule: 'Matricule ' + i,
        qualite: 'Qualité ' + i,
        nom: 'Nom ' + i,
        prenoms: 'Prénoms ' + i,
        categorie: 'Catégorie ' + i,
        salaire_brut: Math.floor(Math.random() * 100000), // Random salary
        salaire_net: Math.floor(Math.random() * 100000), // Random salary
        appreciation_eia: 'Appréciation EIA ' + i,
        promo_categorie: 'Promo Catégorie ' + i,
        aug_montant: Math.floor(Math.random() * 10000), // Random amount
        gratif_taux: Math.random() > 0.5 ? 'Taux' : 'Pas de taux',
        gratif_montant: Math.floor(Math.random() * 10000), // Random amount
        bonus_montant: Math.floor(Math.random() * 10000), // Random amount
        commentaire_gec: 'Commentaire GEC ' + i,
        statut: Math.random() > 0.5 ? 'Active' : 'Inactive',
      };
      data.push(item);
    }
    return data;
  }
}
